import { useNavigate } from 'react-router-dom';

export default function StyleCTA() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 overflow-hidden">
      {/* Background */}
      <img
        src="https://readdy.ai/api/search-image?query=luxurious%20fashion%20boutique%20interior%20with%20warm%20cream%20tones%20soft%20lighting%20elegant%20clothing%20racks%20minimalist%20decor%20cozy%20atmosphere%20high%20end%20retail%20store%20photography%20wide%20angle&width=1440&height=500&seq=stylecta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1E1610]/85 via-[#1E1610]/70 to-[#1E1610]/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
        <div className="text-left max-w-xl">
          <p className="font-sans text-[1rem] text-[#E8D09A] tracking-widest mb-4 font-medium">
            VISIT US IN TAICHUNG
          </p>
          <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-white font-semibold leading-[1.4] mb-5">
            親自來台中門市試穿，<br />讓造型師為妳量身搭配
          </h2>
          <p className="font-sans text-[1.1875rem] text-white/70 leading-[1.75]">
            所有指南中的單品皆可在台中旗艦門市實際試穿，專業造型顧問將協助妳找到最適合的版型與配色。
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
          <button
            onClick={() => navigate('/')}
            className="whitespace-nowrap font-sans text-[1.0625rem] font-medium bg-white text-[#2C2118] px-8 py-3.5 rounded-full hover:bg-[#FDFAF5] transition-all duration-300 cursor-pointer"
          >
            查看限時特惠
          </button>
          <button
            onClick={() => navigate('/')}
            className="whitespace-nowrap font-sans text-[1.0625rem] font-medium border border-white/50 text-white px-8 py-3.5 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            找到我們的門市
          </button>
        </div>
      </div>
    </section>
  );
}
